/*
 * Copyright (c)  2021 CalAmp Corp.  All Rights Reserved
 */

// [ION-CORE TODO]: Remove file when sensor endpoint is ready
export const sensorResponse = {
  response : {
    searchableProperties : {
      mobileIdType : '',
      accountId    : '',
      deviceId     : '',
      messageTime  : 'yyyy-MM-ddTHH:mm:ss.SSSZ',
      mobileId     : '',
      sensorType   : '',
      assetId      : '',
      messageUuid  : ''
    },
    search : {
      maxResults  : 4,
      searchTerms : {
        mobileIdType : 'ESN',
        mobileId     : '4674900206'
      },
      sort : [
        '-messageTime'
      ]
    },
    queryTime  : 162,
    totalCount : 1796,
    results    : [
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/394971',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'QA-SMART-0206'
          },
          operators : [
            {
              href   : 'https://qa.connect.calamp.com/connect/services/operators/70080',
              rel    : 'primary-operator',
              status : 'Enabled',
              title  : 'Operatortest,Dinesh',
              type   : 'OPERATOR'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/66774',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR3,Sunil',
              type       : 'service',
              category   : 'OperatorCategory1',
              externalId : 'Alias_8056'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/64348',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR2,Sunil',
              type       : 'delivery',
              category   : 'OperatorCategory1',
              externalId : 'OPR2_0404'
            }
          ],
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/414312',
            rel    : 'device',
            status : 'Enabled',
            title  : 'smarter_trailer_device_live'
          },
          mobileId     : '4674900206',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2021-08-27T10:16:21.000Z',
          messageUuid  : 'd3f60913-071f-11ec-b144-0db9cae17e1b',
          sensorType   : 'CargoSense',
          data         : [
            {
              sensorTag : 'H',
              sensorId  : '0',
              details   : [
                {
                  label : 'zone 0 Height',
                  value : '100'
                },
                {
                  label : 'zone 0 Status',
                  value : 'VU'
                }
              ]
            },
            {
              sensorTag : 'H',
              sensorId  : '1',
              details   : [
                {
                  label : 'zone 0 Height',
                  value : '90'
                },
                {
                  label : 'zone 0 Status',
                  value : 'VU'
                }
              ]
            },
            {
              sensorTag : 'H',
              sensorId  : '2',
              details   : [
                {
                  label : 'zone 0 Height',
                  value : '80'
                },
                {
                  label : 'zone 0 Status',
                  value : 'VU'
                }
              ]
            },
            {
              sensorTag : 'H',
              sensorId  : '3',
              details   : [
                {
                  label : 'zone 0 Height',
                  value : '70'
                },
                {
                  label : 'zone 0 Status',
                  value : 'VU'
                }
              ]
            },
            {
              sensorTag : 'H',
              sensorId  : '4',
              details   : [
                {
                  label : 'zone 0 Height',
                  value : '0'
                },
                {
                  label : 'zone 0 Status',
                  value : 'IU'
                }
              ]
            }
          ]
        }
      },
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/394971',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'QA-SMART-0206'
          },
          operators : [
            {
              href   : 'https://qa.connect.calamp.com/connect/services/operators/70080',
              rel    : 'primary-operator',
              status : 'Enabled',
              title  : 'Operatortest,Dinesh',
              type   : 'OPERATOR'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/66774',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR3,Sunil',
              type       : 'service',
              category   : 'OperatorCategory1',
              externalId : 'Alias_8056'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/64348',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR2,Sunil',
              type       : 'delivery',
              category   : 'OperatorCategory1',
              externalId : 'OPR2_0404'
            }
          ],
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/414312',
            rel    : 'device',
            status : 'Enabled',
            title  : 'smarter_trailer_device_live'
          },
          mobileId     : '4674900206',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2021-08-27T10:16:21.000Z',
          messageUuid  : 'd3f60913-071f-11ec-b144-0db9cae17e1b',
          sensorType   : 'WETS',
          data         : [
            {
              sensorTag : 'WD1',
              sensorId  : '2418196711',
              details   : [
                {
                  label : 'pressure',
                  value : '256',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_8',
                  value : '3.55',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '93',
                  units : 'F'
                },
                {
                  label : 'status',
                  value : '16'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '8'
                }
              ]
            },
            {
              sensorTag : 'WD1',
              sensorId  : '2418203098',
              details   : [
                {
                  label : 'pressure',
                  value : '259',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_9',
                  value : '12.1',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '204',
                  units : 'F'
                },
                {
                  label : 'status',
                  value : '16'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '9'
                }
              ]
            },
            {
              sensorTag : 'WD1',
              sensorId  : '2418201799',
              details   : [
                {
                  label : 'pressure',
                  value : '257',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_10',
                  value : '2.55',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '115',
                  units : 'F'
                },
                {
                  label : 'status',
                  value : '68'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '10'
                }
              ]
            },
            {
              sensorTag : 'WD1',
              sensorId  : '2418203031',
              details   : [
                {
                  label : 'pressure',
                  value : '258',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_11',
                  value : '8.55',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '34',
                  units : 'F'
                },
                {
                  label : 'status',
                  value : '68'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '11'
                }
              ]
            }
          ]
        }
      },
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/394971',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'QA-SMART-0206'
          },
          operators : [
            {
              href   : 'https://qa.connect.calamp.com/connect/services/operators/70080',
              rel    : 'primary-operator',
              status : 'Enabled',
              title  : 'Operatortest,Dinesh',
              type   : 'OPERATOR'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/66774',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR3,Sunil',
              type       : 'service',
              category   : 'OperatorCategory1',
              externalId : 'Alias_8056'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/64348',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR2,Sunil',
              type       : 'delivery',
              category   : 'OperatorCategory1',
              externalId : 'OPR2_0404'
            }
          ],
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/414312',
            rel    : 'device',
            status : 'Enabled',
            title  : 'smarter_trailer_device_live'
          },
          mobileId     : '4674900206',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2021-08-27T10:16:21.000Z',
          messageUuid  : 'd3f60913-071f-11ec-b144-0db9cae17e1b',
          sensorType   : 'TPMS',
          data         : [
            {
              sensorTag : 'TD1',
              sensorId  : '2418199621',
              details   : [
                {
                  label : 'pressure',
                  value : '116',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_0',
                  value : '9.05',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '304',
                  units : 'F'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '0'
                },
                {
                  label : 'highPressure',
                  value : 'true'
                }
              ]
            },
            {
              sensorTag : 'TD1',
              sensorId  : '2418203225',
              details   : [
                {
                  label : 'pressure',
                  value : '124',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_1',
                  value : '10.03',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '109',
                  units : 'F'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '1'
                }
              ]
            },
            {
              sensorTag : 'TD1',
              sensorId  : '2418201660',
              details   : [
                {
                  label : 'pressure',
                  value : '101',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_2',
                  value : '7.55',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '115',
                  units : 'F'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '2'
                }
              ]
            },
            {
              sensorTag : 'TD1',
              sensorId  : '2418201753',
              details   : [
                {
                  label : 'pressure',
                  value : '260',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '259'
                },
                {
                  label : 'Battery Voltage_3',
                  value : '6.34',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '121',
                  units : 'F'
                },
                {
                  label : 'lowPressure',
                  value : 'true'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '3'
                }
              ]
            },
            {
              sensorTag : 'TD1',
              sensorId  : '2418203232',
              details   : [
                {
                  label : 'pressure',
                  value : '135',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_4',
                  value : '8.55',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '286',
                  units : 'F'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '4'
                }
              ]
            },
            {
              sensorTag : 'TD1',
              sensorId  : '2418199666',
              details   : [
                {
                  label : 'pressure',
                  value : '98',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_5',
                  value : '0.55',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '132',
                  units : 'F'
                },
                {
                  label : 'highPressureAlarm',
                  value : 'true'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '5'
                }
              ]
            },
            {
              sensorTag : 'TD1',
              sensorId  : '2418199677',
              details   : [
                {
                  label : 'pressure',
                  value : '107',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_6',
                  value : '6.65',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '137',
                  units : 'F'
                },
                {
                  label : 'highPressureAlarm',
                  value : 'true'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '6'
                }
              ]
            },
            {
              sensorTag : 'TD1',
              sensorId  : '2418201464',
              details   : [
                {
                  label : 'pressure',
                  value : '67',
                  units : 'Psi'
                },
                {
                  label : 'accelerometerX',
                  value : '251'
                },
                {
                  label : 'accelerometerZ',
                  value : '275'
                },
                {
                  label : 'Battery Voltage_7',
                  value : '9.55',
                  units : 'V',
                  type  : 'Voltage'
                },
                {
                  label : 'temperature',
                  value : '143',
                  units : 'F'
                },
                {
                  label : 'highPressureAlarm',
                  value : 'true'
                },
                {
                  label : 'frameId',
                  value : '0'
                },
                {
                  label : 'wheelPosition',
                  value : '7'
                }
              ]
            }
          ]
        }
      },
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/531703',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'ST_1088'
          },
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/636489',
            rel    : 'device',
            status : 'Enabled',
            title  : 'ST_6002036654'
          },
          mobileId     : '6002036654',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2023-04-12T18:33:58.000Z',
          messageUuid  : '9735daa3-d960-11ed-9178-1379cd83449a',
          sensorType   : 'BMS',
          data         : [
            {
              sensorTag      : 'BS1',
              sensorMetaData : {
                type : 'BMS'
              },
              details : [
                {
                  label : 'frontLeft',
                  value : '12',
                  units : '%',
                  type  : 'Brake Pad Thickness Remaining'
                },
                {
                  label : 'rearLeft',
                  value : '64',
                  units : '%',
                  type  : 'Brake Pad Thickness Remaining'
                },
                {
                  label : 'rearRight',
                  value : '98',
                  units : '%',
                  type  : 'Brake Pad Thickness Remaining'
                },
                {
                  label : 'frontRight',
                  value : '36',
                  units : '%',
                  type  : 'Brake Pad Thickness Remaining'
                }
              ]
            }
          ]
        }
      },
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/531703',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'ST_1088'
          },
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/636489',
            rel    : 'device',
            status : 'Enabled',
            title  : 'ST_6002036654'
          },
          mobileId     : '6002036654',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2023-04-12T18:03:55.000Z',
          messageUuid  : '64a9793e-d95c-11ed-9178-05415880e921',
          sensorType   : 'BMS',
          data         : [
            {
              sensorTag      : 'BC1',
              sensorMetaData : {
                type : 'BMS'
              },
              details : [
                {
                  label : 'frontLeftServiceBrakePressure',
                  value : '207.00',
                  units : 'kPa',
                  type  : 'Pressure'
                },
                {
                  label : 'parkingBrakeStatus',
                  value : '1'
                },
                {
                  label : 'frontLeftParkingBrakePressure',
                  value : '345.00',
                  units : 'kPa',
                  type  : 'Pressure'
                },
                {
                  label : 'frontRightServiceBrakePressure',
                  value : '310.00',
                  units : 'kPa',
                  type  : 'Pressure'
                },
                {
                  label : 'frontRightParkingBrakePressure',
                  value : '379.00',
                  units : 'kPa',
                  type  : 'Pressure'
                },
                {
                  label : 'rearLeftServiceBrakePressure',
                  value : '552.00',
                  units : 'kPa',
                  type  : 'Pressure'
                },
                {
                  label : 'rearLeftParkingBrakePressure',
                  value : '586.00',
                  units : 'kPa',
                  type  : 'Pressure'
                },
                {
                  label : 'rearRightServiceBrakePressure',
                  value : '896.00',
                  units : 'kPa',
                  type  : 'Pressure'
                },
                {
                  label : 'rearRightParkingBrakePressure',
                  value : '931.00',
                  units : 'kPa',
                  type  : 'Pressure'
                }
              ]
            }
          ]
        }
      }
    ]
  }
};

export const doorSensorHistoryResponse = {
  response : {
    searchableProperties : {
      mobileIdType : '',
      accountId    : '',
      deviceId     : '',
      messageTime  : 'yyyy-MM-ddTHH:mm:ss.SSSZ',
      mobileId     : '',
      sensorType   : '',
      assetId      : '',
      messageUuid  : ''
    },
    search : {
      maxResults  : 4,
      searchTerms : {
        mobileIdType : 'ESN',
        mobileId     : '4674900206',
        sensorType   : 'DoorState'
      },
      sort : [
        '-messageTime'
      ]
    },
    queryTime  : 533,
    totalCount : 285,
    results    : [
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/394971',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'QA-SMART-0206'
          },
          operators : [
            {
              href   : 'https://qa.connect.calamp.com/connect/services/operators/70080',
              rel    : 'primary-operator',
              status : 'Enabled',
              title  : 'Operatortest,Dinesh',
              type   : 'OPERATOR'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/66774',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR3,Sunil',
              type       : 'service',
              category   : 'OperatorCategory1',
              externalId : 'Alias_8056'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/64348',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR2,Sunil',
              type       : 'delivery',
              category   : 'OperatorCategory1',
              externalId : 'OPR2_0404'
            }
          ],
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/414312',
            rel    : 'device',
            status : 'Enabled',
            title  : 'smarter_trailer_device_live'
          },
          mobileId     : '4674900206',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2021-09-10T13:18:01.000Z',
          messageUuid  : '86bf4320-1239-11ec-a683-b372bb5eac39',
          sensorType   : 'DoorState',
          data         : [
            {
              sensorTag : 'DS',
              details   : [
                {
                  label : 'doorState 1',
                  value : 'C'
                },
                {
                  label : 'batteryLevel 1',
                  value : 'L'
                }
              ]
            }
          ]
        }
      },
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/394971',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'QA-SMART-0206'
          },
          operators : [
            {
              href   : 'https://qa.connect.calamp.com/connect/services/operators/70080',
              rel    : 'primary-operator',
              status : 'Enabled',
              title  : 'Operatortest,Dinesh',
              type   : 'OPERATOR'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/66774',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR3,Sunil',
              type       : 'service',
              category   : 'OperatorCategory1',
              externalId : 'Alias_8056'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/64348',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR2,Sunil',
              type       : 'delivery',
              category   : 'OperatorCategory1',
              externalId : 'OPR2_0404'
            }
          ],
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/414312',
            rel    : 'device',
            status : 'Enabled',
            title  : 'smarter_trailer_device_live'
          },
          mobileId     : '4674900206',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2021-09-10T13:08:00.000Z',
          messageUuid  : '20414674-1238-11ec-a683-3f8535f36422',
          sensorType   : 'DoorState',
          data         : [
            {
              sensorTag : 'DS',
              details   : [
                {
                  label : 'doorState 1',
                  value : 'O'
                },
                {
                  label : 'batteryLevel 1',
                  value : 'N'
                }
              ]
            }
          ]
        }
      },
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/394971',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'QA-SMART-0206'
          },
          operators : [
            {
              href   : 'https://qa.connect.calamp.com/connect/services/operators/70080',
              rel    : 'primary-operator',
              status : 'Enabled',
              title  : 'Operatortest,Dinesh',
              type   : 'OPERATOR'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/66774',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR3,Sunil',
              type       : 'service',
              category   : 'OperatorCategory1',
              externalId : 'Alias_8056'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/64348',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR2,Sunil',
              type       : 'delivery',
              category   : 'OperatorCategory1',
              externalId : 'OPR2_0404'
            }
          ],
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/414312',
            rel    : 'device',
            status : 'Enabled',
            title  : 'smarter_trailer_device_live'
          },
          mobileId     : '4674900206',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2021-09-10T12:57:58.000Z',
          messageUuid  : 'b9bfee68-1236-11ec-a683-17d58bfe338e',
          sensorType   : 'DoorState',
          data         : [
            {
              sensorTag : 'DS',
              details   : [
                {
                  label : 'doorState 1',
                  value : 'C'
                },
                {
                  label : 'batteryLevel 1',
                  value : 'N'
                }
              ]
            }
          ]
        }
      },
      {
        sensorData : {
          account : {
            href   : 'https://qa.connect.calamp.com/connect/services/accounts/5099',
            rel    : 'account',
            status : 'Enabled',
            title  : 'QA Lab Devices'
          },
          asset : {
            href   : 'https://qa.connect.calamp.com/connect/services/assets/394971',
            rel    : 'asset',
            status : 'Enabled',
            title  : 'QA-SMART-0206'
          },
          operators : [
            {
              href   : 'https://qa.connect.calamp.com/connect/services/operators/70080',
              rel    : 'primary-operator',
              status : 'Enabled',
              title  : 'Operatortest,Dinesh',
              type   : 'OPERATOR'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/66774',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR3,Sunil',
              type       : 'service',
              category   : 'OperatorCategory1',
              externalId : 'Alias_8056'
            },
            {
              href       : 'https://qa.connect.calamp.com/connect/services/operators/64348',
              rel        : 'operator',
              status     : 'Enabled',
              title      : 'OPR2,Sunil',
              type       : 'delivery',
              category   : 'OperatorCategory1',
              externalId : 'OPR2_0404'
            }
          ],
          device : {
            href   : 'https://qa.connect.calamp.com/connect/services/devices/414312',
            rel    : 'device',
            status : 'Enabled',
            title  : 'smarter_trailer_device_live'
          },
          mobileId     : '4674900206',
          mobileIdType : 'ESN',
          receiverId   : '6.14336.10496',
          messageTime  : '2021-09-10T12:47:57.000Z',
          messageUuid  : '534ec2fc-1235-11ec-a683-0930ab01f763',
          sensorType   : 'DoorState',
          data         : [
            {
              sensorTag : 'DS',
              details   : [
                {
                  label : 'doorState 1',
                  value : 'O'
                },
                {
                  label : 'batteryLevel 1',
                  value : 'N'
                }
              ]
            }
          ]
        }
      }
    ]
  }
};
